import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9fc7a74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "confirm-container"
}
const _hoisted_2 = { class: "confirm-dialog" }
const _hoisted_3 = { class: "confirm-content" }
const _hoisted_4 = { class: "confirm-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "confirm-overlay",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOverlayClick && _ctx.onOverlayClick(...args)))
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNoClick && _ctx.onNoClick(...args)))
                  }, "キャンセル"),
                  _createElementVNode("button", {
                    class: "button primary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onYesClick && _ctx.onYesClick(...args)))
                  }, "OK")
                ])
              ])
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}